import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { RESERVATION_EVENTS, trackReservation } from "./tracking";

// "Ready someday, not today?" — the web41 entry point under a Start Free Trial
// button. Plain text link with low visual weight (design doc): a secondary
// path that must not compete with the primary CTA.
// The bottom slot sits inside the pricing CTA wrapper, which already spaces
// its children with a flex gap; only the hero slot needs its own margin.
const Wrap = styled.div<{ $position: "hero" | "bottom" }>`
  text-align: center;
  font-family: Lato, sans-serif;
  /* hero: mirror the bottom slot's gap (16px, 24px from 768px) */
  margin-top: ${({ $position }) => ($position === "hero" ? "16px" : "0")};
  @media (min-width: 768px) {
    margin-top: ${({ $position }) => ($position === "hero" ? "24px" : "0")};
  }
`;

const EntryLink = styled.button`
  background: none;
  border: 0;
  padding: 0;
  font-family: Lato, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #0b6dff;
  text-decoration: underline;
  cursor: pointer;
`;

const Caption = styled.div`
  margin-top: 4px;
  font-size: 13px;
  line-height: 18px;
  color: #7d8da6;
`;

export function ReservationEntry({ position }: { position: "hero" | "bottom" }) {
  const navigate = useNavigate();
  return (
    <Wrap $position={position} data-reservation-entry={position}>
      <EntryLink
        type="button"
        onClick={() => {
          trackReservation(RESERVATION_EVENTS.entryClicked, { position });
          navigate("/reserve");
        }}
      >
        Ready someday, not today?
      </EntryLink>
      <Caption>Reserve your future start date and lock today&apos;s price</Caption>
    </Wrap>
  );
}
